import { injectable } from "inversify-props"
import {
	DisparoDeMensagemVoucherCommand,
	enviaComprovanteDaVendaViaMensageriaAlmode,
	enviaFechamentoDeCaixaViaMensageriaAlmode,
	enviaValePresenteViaMensageriaAlmode,
	enviaIdentificadorDoPedidoCriadoViaMensageriaAlmode,
	enviaLinkPagamentoAsaasViaMensageriaAlmode,
	enviaAcaoDeCashbackViaMensageriaAlmode,
	enviarAvaliacaoNpsViaMensageriaAlmode,
} from "@/api/pluginMensageriaAlmode"
import { PluginMensageriaAlmodeServiceAdapter } from "@/usecases/mensageriaAlmode/adapter/PluginMensageriaAlmodeServiceAdapter"

@injectable()
export class PluginMensageriaAlmodeService implements PluginMensageriaAlmodeServiceAdapter {
	enviaComprovanteDaVendaViaMensageriaAlmode = (vendaId: string, novoTelefone?: string) =>
		enviaComprovanteDaVendaViaMensageriaAlmode(vendaId, novoTelefone)

	enviaFechamentoDeCaixaViaMensageriaAlmode = (wppFechamento: string, body: { base64: string; lojaId: string; pdvId: string }) =>
		enviaFechamentoDeCaixaViaMensageriaAlmode(wppFechamento, body)

	enviaValePresenteViaMensageriaAlmode = (vendaId: string) =>
		enviaValePresenteViaMensageriaAlmode(vendaId)

	enviaIdentificadorDoPedidoCriadoViaMensageriaAlmode = (lojaId: string, identificador: string) =>
		enviaIdentificadorDoPedidoCriadoViaMensageriaAlmode(lojaId, identificador)

	enviaLinkPagamentoAsaasViaMensageriaAlmode = (lojaId: string, body: any) =>
		enviaLinkPagamentoAsaasViaMensageriaAlmode(lojaId, body)

	enviaAcaoDeCashbackViaMensageriaAlmode = (command: DisparoDeMensagemVoucherCommand) =>
		enviaAcaoDeCashbackViaMensageriaAlmode(command)

	enviarAvaliacaoNpsViaMensageriaAlmode = (vendaId: string) => enviarAvaliacaoNpsViaMensageriaAlmode(vendaId)
}
